import { useState } from 'react'
import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'
import ServiceNew from '../components/pages-new/ServiceNew'
import Layout from '../components/common/Layout'
import {
  Grid,
  useMediaQuery,
  Container,
  makeStyles,
  useTheme,
  Link as MuiLink,
} from '@material-ui/core'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import SearchIcon from '@material-ui/icons/Search'
import CarouselSp2 from '../components/ui/CarouselSp2'
import ButtonSp from '../components/ui/ButtonSp'
import ModalSp from '../components/ui/ModalSp'
import Couriers from '../components/common/Couriers'
import ReactPlayer from 'react-player'
import getConfig from 'next/config'
import Axios from 'axios'
import LazyLoad from 'react-lazyload'
import LazyloadPlaceholder from '../components/ui/LazyloadPlaceholder'

import Link from '../components/utility/CustomLink'
import { useTranslation } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import clsx from 'clsx'

const { publicRuntimeConfig } = getConfig()

const HowtoCarousel = dynamic(() =>
  import('../components/servicesPage/HowtoCarousel')
)

const textBtn = (text, onClick = null) => (
  <MuiLink component="button" onClick={onClick} style={{ paddingLeft: 0 }}>
    <p>
      {text} {'>'}
    </p>
  </MuiLink>
)

const renderShopPics = () => {
  return [1, 2, 3, 4, 5, 6, 7].map((num) => (
    <div key={num}>
      <img
        src={`/static/img/services/shop/sp0${num}.jpg`}
        alt="ตัวอย่าง shippop shop"
        style={{ height: 190, borderRadius: 6 }}
      />
    </div>
  ))
}

const useStyles = makeStyles((theme) => ({
  root: {
    ...theme.homeStyle.root,
  },
  heroImage: {
    backgroundImage:
      'linear-gradient(90deg, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0) 100%), url("/static/img/services/service-cover.jpg")',
    height: theme.homeStyle.heroImageHeightDesktop,
    width: '100%',
    backgroundPosition: 'right',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    [theme.breakpoints.only('sm')]: {
      padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
    },
    [theme.breakpoints.down('xs')]: {
      backgroundImage:
        'linear-gradient(0deg, rgba(0,0,0,1) 0%, rgba(0,0,0,0) 100%), url("/static/img/services/service-hero-img-mobile.jpeg")',
      height: theme.homeStyle.heroImageHeightMobile,
      padding: `${theme.spacing(2)}px ${theme.spacing(0)}px`,
    },
  },
  heroText: {
    textAlign: 'left',
    color: 'white',
    marginBottom: theme.spacing(10),
    [theme.breakpoints.down('xs')]: {
      transform: 'none',
      marginBottom: theme.spacing(2),
    },
  },
  heroTitle: {
    ...theme.homeStyle.heroTitle,
    marginTop: 0,
  },
  heroSubtitle: {
    ...theme.homeStyle.heroSubtitle,
  },
  lineBtn: {
    padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
    marginTop: theme.spacing(1),
  },
  services: {
    width: '100%',
    ...theme.homeStyle.section,
    padding: `${theme.spacing(6)}px 0`,
  },
  serviceBox: {
    width: '100%',
    margin: `${theme.spacing(1)}px auto`,
    textAlign: 'left',
    '& img': {
      width: '100%',
      maxWidth: 500,
      maxHeight: 460,
      objectFit: 'contain',
    },
    '& h1': {
      fontWeight: 400,
      fontSize: 32,
      ...theme.headerFont,
      color: '#404041',
      marginBottom: 0,
      marginTop: 0,
      [theme.breakpoints.down('xs')]: {
        fontSize: 22,
      },
    },
    '& h2': {
      ...theme.homeStyle.bodyText,
      color: '#828282',
    },
    '& p': {
      fontWeight: 400,
      fontSize: 16,
      margin: 0,
    },
  },
  franchise: {
    ...theme.homeStyle.section,
    [theme.breakpoints.down('xs')]: {
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
  title: {
    ...theme.homeStyle.title,
  },
  subtitle: {
    ...theme.homeStyle.subtitle,
  },
  examplesDesc: {
    fontWeight: 400,
    fontSize: 18,
    marginTop: theme.spacing(3),
    [theme.breakpoints.down('xs')]: {
      fontSize: 16,
    },
  },
  blackLink: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    color: '#828282',
    cursor: 'pointer',
    marginBottom: theme.spacing(1),
    '&:hover': {
      color: theme.palette.primary.main,
    },
    '& dl': {
      textDecoration: 'underline',
      margin: 0,
      marginLeft: theme.spacing(0.5),
    },
    whiteSpace: 'nowrap',
  },
  smallGreyText: {
    color: '#828282',
    fontSize: 12,
    marginTop: theme.spacing(0.5),
  },
  noPaddingX: {
    paddingLeft: '0 !important',
    paddingRight: '0 !important',
  },
}))

export async function getServerSideProps(context) {
  const translations = await serverSideTranslations(context.locale, [
    'common',
    'header',
    'footer',
    'pdpa',
    'services',
  ])

  // Courier logos are rendered only by the old design (?old). The default new
  // design never uses them, so don't make every visitor wait on
  // /api/get-couriers-logo (courier-info): a hang there used to hang this page.
  if (!('old' in context.query)) {
    return { props: { ...translations } }
  }

  try {
    const {
      data: { iconsPairs },
    } = await Axios.get(
      `${publicRuntimeConfig.siteDomain}/api/get-couriers-logo`
    )
    return { props: { couriers: iconsPairs, ...translations } }
  } catch (err) {
    return { props: { couriers: [[]], ...translations } }
  }
}

const ServicesPageOld = ({ couriers = [[]] }) => {
  const [comparePriceOpen, setComparePriceOpen] = useState(false)
  const [printCoverOpen, setPrintCoverOpen] = useState(false)

  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))
  const isTablet = useMediaQuery(theme.breakpoints.only('sm'))

  const classes = useStyles()

  const { t } = useTranslation('services')

  const businessFeatures = [
    t('franchise-bullet-1'),
    t('franchise-bullet-2'),
    t('franchise-bullet-3'),
  ]

  const services = [
    {
      imgFileName: 'service-compare-price-2.png',
      title: t('services.compare-prices.title'),
      desc: t('services.compare-prices.desc'),
      linkToAction: (
        <Link href="/checkprice" passHref>
          <a className={classes.blackLink}>
            <SearchIcon />
            <dl>{t('compare-price-modal.go-to-checkprice')}</dl>
          </a>
        </Link>
      ),
      buttonEl: textBtn(t('services.checkprice-read-more'), () =>
        setComparePriceOpen(true)
      ),
    },
    {
      imgFileName: 'service-create-order.jpg',
      title: t('services.create-shipment.title'),
      desc: t('services.create-shipment.desc'),
      buttonEl: (
        <>
          <a
            href={`${publicRuntimeConfig.appShippop}/order/create/`}
            target="_blank"
          >
            {textBtn(t('services.go-to-create-order'))}
          </a>
          <dl className={classes.smallGreyText}>
            {t('services.login-required')}
          </dl>
        </>
      ),
    },
    {
      imgFileName: 'service-print-cover.jpg',
      title: t('services.print-shipping-label.title'),
      desc: t('services.print-shipping-label.desc'),
      buttonEl: textBtn(t('services.print-label-read-more'), () =>
        setPrintCoverOpen(true)
      ),
    },
    {
      imgFileName: 'service-pick-up.jpg',
      title: t('services.pick-up-or-drop-off.title'),
      desc: t('services.pick-up-or-drop-off.desc'),
      buttonEl: (
        <Link href="/nearby-dropoff" passHref>
          <a>{textBtn(t('services.find-dropoff'))}</a>
        </Link>
      ),
    },
    {
      imgFileName: 'service-cod.jpg',
      title: t('services.cod.title'),
      desc: t('services.cod.desc'),
      buttonEl: (
        <Link href="/faq?search=cod" passHref>
          <a>{textBtn(t('services.conditions-and-howto'))}</a>
        </Link>
      ),
    },
    {
      imgFileName: 'service-sms.jpg',
      title: t('services.sms-noti.title'),
      desc: t('services.sms-noti.desc'),
    },
    {
      imgFileName: 'service-cs.jpg',
      title: t('services.customer-service.title'),
      desc: t('services.customer-service.desc'),
      buttonEl: (
        <a href="https://line.me/ti/p/%40shippop" target="_blank">
          <ButtonSp
            variant="outlined"
            color="default"
            className={classes.lineBtn}
          >
            <img
              src="/static/img/LINE_APP.svg"
              style={{ maxWidth: 25, marginRight: 10 }}
              alt="SHIPPOP LINE"
            />
            {t('services.line')}
          </ButtonSp>
        </a>
      ),
    },
    {
      imgFileName: 'shippop_insurance.png',
      title: t('services.warranty.title'),
      desc: t('services.warranty.desc'),
      buttonEl: (
        <Link href="/faq?search=insurance" passHref>
          <a>{textBtn(t('services.how-to-claim'))}</a>
        </Link>
      ),
    },
  ]

  const renderService = (
    { imgFileName, title, desc, linkToAction = null, buttonEl = null },
    index
  ) => {
    const path = `/static/img/services/${imgFileName}`
    const reverseProp = () => {
      if (index % 2) return 'row-reverse'
      else return 'row'
    }
    return (
      <Grid
        container
        spacing={5}
        direction={reverseProp()}
        key={index}
        className={classes.serviceBox}
      >
        <Grid
          item
          xs={12}
          md={6}
          container
          direction="column"
          alignItems="center"
          justify="center"
          className={clsx(isMobile && classes.noPaddingX)}
        >
          <img src={path} alt={title} />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          container
          direction="column"
          alignItems="flex-start"
          justify="flex-start"
          className={clsx(isMobile && classes.noPaddingX)}
        >
          <h1>{title}</h1>
          <h2>{desc}</h2>
          {linkToAction}
          {buttonEl}
        </Grid>
      </Grid>
    )
  }

  const checkpriceSlides = [
    {
      img: 'checkprice-1.jpg',
      imgMobile: 'checkprice-m1.png',
      text: 'compare-price-modal.step1',
    },
    {
      img: 'checkprice-2.jpg',
      imgMobile: 'checkprice-m2.png',
      text: 'compare-price-modal.step2',
      greyText: t('compare-price-modal.step2-2'),
    },
    {
      img: 'checkprice-3.jpg',
      imgMobile: 'checkprice-m3.png',
      text: 'compare-price-modal.step3',
    },
    {
      img: 'checkprice-4.jpg',
      imgMobile: 'checkprice-m4.png',
      text: 'compare-price-modal.step4',
    },
    {
      img: 'checkprice-5.jpg',
      imgMobile: 'checkprice-m5.png',
      text: 'compare-price-modal.step5',
      linkToAction: (
        <Link href="/checkprice" passHref>
          <MuiLink>
            <u>{t('compare-price-modal.go-to-checkprice')}</u>
          </MuiLink>
        </Link>
      ),
    },
  ]

  const printLabelSlides = [
    {
      img: 'print-1.jpg',
      imgMobile: 'print-m1.jpg',
      text: 'print-label-modal.step1',
    },
    {
      img: 'print-2.jpg',
      imgMobile: 'print-m2.jpg',
      text: 'print-label-modal.step2',
    },
    {
      img: 'print-3.jpg',
      imgMobile: 'print-m3.jpg',
      text: 'print-label-modal.step3',
      greyText: (
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <dl style={{ margin: 0, marginRight: 8 }}>
            {t('print-label-modal.step3-2')}{' '}
            <Link href="/register" passHref>
              <MuiLink>
                <u>{t('print-label-modal.go-to-register')}</u>
              </MuiLink>
            </Link>
          </dl>
        </div>
      ),
    },
  ]

  return (
    <Layout
      title="บริการของ SHIPPOP - ส่งของ ส่งพัสดุ เช็คราคา เช็คค่าส่ง"
      keywords="บริการขนส่ง, ส่งของ, เช็คค่าส่ง, ใบปะหน้าพัสดุ, ใบปะหน้ากล่อง"
      description="SHIPPOP จองขนส่ง ส่งพัสดุ บริการส่งพัสดุ เช็คราคาค่าส่ง สร้างรายการส่งของ ติดตามพัสดุ พิมพ์ใบปะหน้าพัสดุ ครบจบในที่เดียว! เราพร้อมอำนวยความสะดวกในการส่งของให้ง่าย รวดเร็ว และประหยัดเวลามากขึ้น"
    >
      <div>
        <div className={classes.heroImage}>
          <Container maxWidth="lg">
            <div className={classes.heroText}>
              <h1 className={classes.heroTitle}>{t('our-services')}</h1>
              <h2 className={classes.heroSubtitle}>
                {t('our-services-sub-1')}
                {isMobile ? ' ' : <br />}
                {t('our-services-sub-2')}
              </h2>
            </div>
          </Container>
        </div>

        <Container>
          <div className={classes.services}>{services.map(renderService)}</div>
        </Container>
        <LazyLoad offset={1000} placeholder={<LazyloadPlaceholder />}>
          <>
            <Couriers couriers={couriers} />

            <div className={classes.franchise}>
              <Container>
                <h1 className={classes.title}>{t('franchise')}</h1>
                <Grid container style={{ marginBottom: 70, textAlign: 'left' }}>
                  <Grid item xs={12} md={7}>
                    <ReactPlayer
                      url="https://www.youtube.com/watch?v=a5wqaRAJIRU"
                      width="100%"
                      light
                      playing
                      controls
                    />
                  </Grid>
                  <Grid item md={1} />
                  <Grid item xs={12} md={4}>
                    <Grid
                      container
                      style={{ paddingTop: 20 }}
                      direction="column"
                      alignItems="center"
                    >
                      {businessFeatures.map((text) => (
                        <Grid
                          item
                          xs={12}
                          sm={8}
                          md={12}
                          container
                          direction="row"
                          justify="flex-start"
                          alignItems="center"
                          wrap="nowrap"
                          key={text}
                        >
                          <CheckCircleIcon
                            color="primary"
                            style={{ margin: 10 }}
                          />
                          <p>{text}</p>
                        </Grid>
                      ))}
                      <Grid
                        item
                        xs={12}
                        container
                        direction="column"
                        alignItems={
                          isMobile || isTablet ? 'center' : 'flex-start'
                        }
                      >
                        <ButtonSp
                          variant="outlined"
                          style={{
                            height: 50,
                            marginTop: theme.spacing(3),
                            width: isMobile ? '100%' : 'auto',
                          }}
                          component="a"
                          href="https://shippop.shop"
                          target="_blank"
                        >
                          {t('interested')}
                        </ButtonSp>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <CarouselSp2
                  slidesPerPage={isMobile ? 1 : isTablet ? 2 : 3}
                  showDots={isMobile}
                  showArrows={!isMobile}
                >
                  {renderShopPics()}
                </CarouselSp2>
                <h2 className={classes.examplesDesc}>{t('example-shop')}</h2>
              </Container>
            </div>
          </>
        </LazyLoad>
        {/* ------- below is modal area -------------------------- */}

        <ModalSp
          title={t('compare-price-modal.title')}
          open={comparePriceOpen}
          onClose={() => setComparePriceOpen(false)}
          ariaLabelledby="compare-modal"
          fullScreen={isMobile}
        >
          <HowtoCarousel slides={checkpriceSlides} topic="checkprice" />
        </ModalSp>
        <ModalSp
          title={t('print-label-modal.title')}
          open={printCoverOpen}
          onClose={() => setPrintCoverOpen(false)}
          ariaLabelledby="print-cover-modal"
          fullScreen={isMobile}
        >
          <HowtoCarousel slides={printLabelSlides} topic="print" />
        </ModalSp>
      </div>
    </Layout>
  )
}

// ?new → new-design variant (new chrome, same content); otherwise the old
// page renders unchanged. Wrapper keeps hook order stable across both paths
// (each branch is its own component, so neither shares the other's hooks).
const ServicesPage = (props) => {
  const { query } = useRouter()
  if ('old' in query) return <ServicesPageOld {...props} />
  return <ServiceNew {...props} />
}

export default ServicesPage
